// Generated from ESF schema: User
// Do not edit manually!
/** User authorization roles */
export var UserRole;
(function (UserRole) {
    UserRole["Admin"] = "admin";
    UserRole["Operator"] = "operator";
    UserRole["Developer"] = "developer";
    UserRole["User"] = "user";
    UserRole["Guest"] = "guest";
})(UserRole || (UserRole = {}));
/** Validate a User object */
export function validateUser(obj) {
    if (typeof obj !== 'object' || obj === null)
        return false;
    const o = obj;
    if (!('createdAt' in o))
        return false;
    if (!('displayName' in o))
        return false;
    if (typeof o.displayName === 'string' && o.displayName.length > 64)
        return false;
    if (!('id' in o))
        return false;
    if (o.id !== undefined && !(o.id instanceof Uint8Array && o.id.length === 32))
        return false;
    if (!('publicKey' in o))
        return false;
    if (!('roles' in o))
        return false;
    if (!('updatedAt' in o))
        return false;
    return true;
}
//# sourceMappingURL=user.js.map